import { withClientState } from 'apollo-link-state';
import locationFragment from '../fragments/location';
import companyFragment from '../fragments/company';
import promotionFragment from '../fragments/promotion';
import claimedPromotionFragment from '../fragments/claimed-promotion';

const resolvers = {
  Query: {
    location: (_, { id }, { cache }) => {
      const location = cache.readFragment({
        fragment: locationFragment.fragment,
        id: `Location:${id}`,
      });
      return location;
    },
    company: (_, { id }, { cache }) => {
      return cache.readFragment({
        fragment: companyFragment.fragment,
        id: `Company:${id}`,
      });
    },
    promotion: (_, { id }, { cache }) => {
      const promotion = cache.readFragment({
        fragment: promotionFragment.fragment,
        id: `Promotion:${id}`,
      });
      return promotion;
    },
    claimedPromotion: (_, { id }, { cache }) => {
      const claimedPromotion = cache.readFragment({
        fragment: claimedPromotionFragment.fragment,
        fragmentName: claimedPromotionFragment.name,
        id: `ClaimedPromotion:${id}`,
      });
      return claimedPromotion;
    },
  },
};

export default (cache, initialState) => {
  return withClientState({
    cache,
    resolvers,
    defaults: initialState,
  });
};
